import { selectLoadedShipmentWarehouseId } from "inbounds/store/selectors/shipments/selectLoadedShipmentWarehouseId";
import { selectIsPrepWarehouse } from "wholesale/detail/store/selectWholesaleOrderDetail";
import { createSelector } from "reselect";
import { RootState } from "RootReducer";

export const selectIsLoadedShipmentWarehousePrepEnabled = createSelector(
  selectLoadedShipmentWarehouseId,
  (state: RootState) => state,
  (warehouseId, state) => selectIsPrepWarehouse(warehouseId)(state)
);
